<template>
  <div class="status-container" :style="styles[data]">
    {{ situacaoDesc[data] }}
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			situacaoDesc: {
				0: 'Recebido',
				1: 'Aprovado',
				2: 'Integrado',
				3: 'Integrado',
				4: 'Concluído',
				5: 'Análise',
				6: 'Digitando',
			},
			styles: {
				0: 'background-color: #18435d; color: #c1d3de;',
				1: 'background-color: #f7f3c4; color: #565004;',
				2: 'background-color: #cbb3da; color: #4a1a67;',
				3: 'background-color: #cbb3da; color: #4a1a67;',
				4: 'background-color: #abdcbc; color: #225233;',
				5: 'background-color: gray;color: #fff;text-align: center;font-weight: bold;-webkit-font-smoothing: antialiased;',
				6: 'background-color: transparent;color: #565656;',
			},
		};
	},
};
</script>

<style scoped>
.status-container {
  display: flex;
  padding: 3px 3px;
  padding-right: 10px;
  padding-left: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  /*    background-color: #ffa01c5d;  */
}
</style>
